export { default } from './PencatatanManual';
